import i18next from 'i18next';
import { __DEBUG__, DEFAULT_LANGUAGE, LANGUAGES } from '../constants';

import commonNl from './locales/nl/common.json';
import routesNl from './locales/nl/routes.json';
import domainsNl from './locales/nl/domains.json';

import commonEn from './locales/en/common.json';
import routesEn from './locales/en/routes.json';

i18next.init({
  ns: ['common', 'routes'],
  defaultNS: 'common',
  fallbackNS: ['common'],
  fallbackLng: DEFAULT_LANGUAGE,
  resources: {
    nl: {
      common: commonNl,
      routes: routesNl,
      domains: domainsNl,
    },
    en: {
      common: commonEn,
      routes: routesEn,
    },
  },
  parseMissingKeyHandler: (missing) => {
    if (__DEBUG__) {
      console.warn('MISSING TRANSLATION:', missing);
    }
    return missing;
  },
});

i18next.languages = Object.keys(LANGUAGES);

export default i18next;
